import { medium, formatTime } from '@/utils/formatDate'

export default {
  props: {
    events: Array,
    depressed: Boolean,
  },
  setup() {
    const headers = [
      {
        text: '№', value: 'id', width: '10%', sortable: false,
      },
      {
        text: 'Дата', value: 'time', width: '30%', sortable: true,
      },
      { text: 'Событие', value: 'text', sortable: false },
    ]

    return {
      medium,
      formatTime,
      headers,
    }
  },
}
